<form [formGroup]="form1" (ngSubmit)="update()">
  <div class="card">
    <div class="card-header text-center" style="text-transform: uppercase">
      EDITAR EMPLEADO
    </div>
    <div class="card-body">
      <div class="row gx-3 mb-3">
        <div class="col-md-12">
          <label class="small mb-1" for="name">Nombre</label>
          <div class="input-group">
            <input type="text" class="form-control text-capitalize" formControlName="name" uppercaseInput />
          </div>
        </div>
        <div class="col-md-12">
          <label class="small mb-1" for="lastname">Apellidos</label>
          <div class="input-group">
            <input type="text" class="form-control text-capitalize" formControlName="lastname" uppercaseInput />
          </div>
        </div>
        <div class="col-md-12">
          <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
          <div class="input-group">
            <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
            <input type="text" class="form-control" formControlName="rut" uppercaseInput
              (keyup)="onFormatRut($event)" />
          </div>
        </div>
        <div class="col-md-7 col-sm-12">
          <label class="small mb-1" for="name">Nombre de la empresa</label>
          <div class="input-group">
            <input type="text" class="form-control text-capitalize" formControlName="company" uppercaseInput />
          </div>
        </div>
        <div class="col-md-5 col-sm-12">
          <label class="small mb-1" for="phone">Tel.</label>
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i></span>
            <input type="email" class="form-control" placeholder="9XXXXXXXX" formControlName="phone" />
          </div>
        </div>
        <div class="col-md-12">
          <label class="small mb-1" for="rut">ESTADO</label>
          <div class="input-group">
            <select class="form-select" formControlName="state_id">
              <option *ngFor="let item of items" [value]="item.id">{{item.tag}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <label class="small mb-1" for="email">Email</label>
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping"><i class="fa-regular fa-envelope"></i></span>
            <input type="email" class="form-control" placeholder="Email  contacto" formControlName="email" />
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <label class="small mb-1" for="phone">Tel.</label>
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i></span>
            <input type="email" class="form-control" placeholder="Telefono contacto" formControlName="phone" />
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <label class="small mb-1" for="phone">Vehículo.</label>
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-truck"></i></span>
            <select formControlName="cars_type" class="form-select">
              <option value="0">SELECCIONE</option>
              <option *ngFor="let item of cars" [value]="item">{{item | uppercase}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <label class="small mb-1" for="phone">PPU.</label>
          <div class="input-group flex-nowrap">
            <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-truck"></i></span>
            <input type="email" class="form-control" placeholder="XXAA-24" formControlName="cars_ppu" />
          </div>
        </div>
        <div class="col-md-12">
          <label class="small mb-1" for="rut">AUTORIZAR EL INGRESO</label><br>

          <div class="mt-2 mb-2 btn-group">
            <input type="radio" formControlName="selday" value="1" class="btn-check" id="success-outlined"
              autocomplete="off" checked>
            <label class="btn btn-outline-secondary btn-sm" for="success-outlined">Días</label>

            <input type="radio" formControlName="selday" value="2" class="btn-check" id="danger-outlined"
              autocomplete="off">
            <label class="btn btn-outline-secondary btn-sm" for="danger-outlined">Fecha</label>
          </div>

          <div *ngIf="form1.get('selday')?.value==1">
            <div class="input-group">
              <div *ngFor="let dia of allDays" class="form-check form-check-inline">
                <input type="checkbox" class="form-check-input" [id]="dia" [value]="dia"
                  [checked]="form1.get('xdays').value.includes(dia)" (change)="toggleDaySelection(dia)" />
                <label class="form-check-label" [for]="dia">{{ dia }}</label>
              </div>
            </div>
            <div *ngIf="form1.hasError('atLeastOneDaySelected') && form1.get('xdays').touched" class="text-danger">
              Al menos un día debe ser seleccionado.
            </div>
          </div>

          <div *ngIf="form1.get('selday')?.value==2">
            <div class="input-group">
              <input type="date" class="form-control" formControlName="date_ing" />
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-primary w-100" type="submit">GUARDAR CAMBIOS</button>
    </div>
  </div>
</form>